<template>
  <v-expansion-panel>
    <v-expansion-panel-header color="transparent">
      <template v-slot:actions>
        <v-icon class="icon mdi-menu-down">$expand</v-icon>
      </template>
      <template v-slot:default>
        <div class="header ml-2">
          <v-row dense>
            <v-col cols="auto" class="text--primary">
              {{ groupedItem.title }} ({{ groupedItem.documents.length }})
            </v-col>
            <v-col
              cols="auto"
              class="text--secondary"
              v-for="field in sumFields"
              v-bind:key="`sum-${field.title}`"
            >
              <span>
                {{ $t("Sum") }} ({{ field.title }}) = {{ field.value }}
              </span>
            </v-col>
            <v-col
              cols="auto"
              class="text--secondary"
              v-for="field in maxFields"
              v-bind:key="`max-${field.title}`"
            >
              <span>
                {{ $t("MaxValue") }} ({{ field.title }}) = {{ field.value }}
              </span>
            </v-col>
            <v-col
              cols="auto"
              class="text--secondary"
              v-for="field in minFields"
              v-bind:key="`min-${field.title}`"
            >
              <span>
                {{ $t("MinValue") }} ({{ field.title }}) = {{ field.value }}
              </span>
            </v-col>
            <v-col
              cols="auto"
              class="text--secondary"
              v-for="field in avgFields"
              v-bind:key="`avg-${field.title}`"
            >
              <span>
                {{ $t("AvgValue") }} ({{ field.title }}) = {{ field.value }}
              </span>
            </v-col>
          </v-row>
        </div>
      </template>
    </v-expansion-panel-header>
    <v-expansion-panel-content eager color="transparent">
      <div v-if="groupedItem.children && groupedItem.children.length > 0">
        <v-expansion-panels multiple accordion flat tile>
          <GroupedDocumentItem
            v-for="groupedItemChild in groupedItem.children"
            v-bind:key="groupedItemChild.title"
            :groupedItem="groupedItemChild"
            :selectedDocument="selectedDocument"
            :defaultVisibleFields="defaultVisibleFields"
            :selectedDocuments="selectedDocuments"
            v-on="$listeners"
          />
        </v-expansion-panels>
      </div>
      <div>
        <DocumentItem
          v-for="document in ungroupedDocuments"
          v-bind:key="document.ObjectID"
          :documentDto="document"
          :isSelected="document.ObjectID == selectedDocument"
          :fieldsCount="defaultVisibleFields"
          :selectedDocuments="selectedDocuments"
          v-on="$listeners"
        />
      </div>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>
<script>
import DocumentItem from "@/components/search/results/list/item/DocumentItem";
import GroupedDocumentItem from "@/components/search/results/list/item/GroupedDocumentItem";
import Utils from "@/ecm/common/Utils.js";
import FieldType from "@/ecm/variables/FieldType";
export default {
  name: "GroupedDocumentItem",
  props: {
    groupedItem: {
      type: Object,
    },
    selectedDocument: {
      type: Number,
    },
    defaultVisibleFields: {
      type: Number,
      default: 4,
    },
    selectedDocuments: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    DocumentItem,
    GroupedDocumentItem,
  },
  created() {},
  data() {
    return {
      documentList: [],
      userDecSep: this.$store.getters["account/user"].MetricDecimalSep,
      userThouSep: this.$store.getters["account/user"].MetricThousandSep,
      userDateFormat: this.$store.getters["account/user"].MetricDateFormat,
    };
  },
  computed: {
    documentsToSummarize() {
      return this.groupedItem.documents.filter(
        (d) =>
          !this.groupedItem.summarizeOnlySelectedDocuments ||
          this.selectedDocuments.includes(d.ObjectID)
      );
    },
    ungroupedDocuments() {
      this.groupedItem.documents.forEach((item) => (item.expand = false));
      if (!this.groupedItem.children || this.groupedItem.children.length == 0) {
        return this.groupedItem.documents;
      } else {
        return this.groupedItem.documents.filter(
          (d) =>
            !this.groupedItem.children.some((ch) =>
              ch.documents.some((chd) => chd.ObjectID == d.ObjectID)
            )
        );
      }
    },
    sumFields() {
      if (
        this.groupedItem.sumFields.length > 0 &&
        this.documentsToSummarize.length > 0
      ) {
        return this.groupedItem.sumFields.map((f) => this.summarize("sum", f));
      }
    },
    maxFields() {
      if (
        this.groupedItem.maxFields.length > 0 &&
        this.documentsToSummarize.length > 0
      ) {
        return this.groupedItem.maxFields.map((f) => this.summarize("max", f));
      }
    },
    minFields() {
      if (
        this.groupedItem.minFields.length > 0 &&
        this.documentsToSummarize.length > 0
      ) {
        return this.groupedItem.minFields.map((f) => this.summarize("min", f));
      }
    },
    avgFields() {
      if (
        this.groupedItem.avgFields.length > 0 &&
        this.documentsToSummarize.length > 0
      ) {
        return this.groupedItem.avgFields.map((f) => this.summarize("avg", f));
      }
    },
  },
  methods: {
    summarize(funcType, fieldTitle) {
      var fieldValues = this.documentsToSummarize
        .filter((gd) =>
          gd.Fields.some((gdf) => gdf.Title == fieldTitle && gdf.Value != "")
        )
        .map((gd) => {
          var field = gd.Fields.find((gdf) => gdf.Title == fieldTitle);
          return field.Type == FieldType.Numeric
            ? Utils.number.fromUserFormat(
                field.Value,
                this.userDecSep,
                this.userThouSep
              )
            : Utils.date.fromUserFormat(field.Value, this.userDateFormat);
        });

      var summarizedValue = "";
      if (fieldValues.length > 0) {
        switch (funcType) {
          case "sum":
            summarizedValue = fieldValues.reduce((a, b) => a + b);
            break;
          case "max":
            summarizedValue = fieldValues.reduce((a, b) => (a > b ? a : b));
            break;
          case "min":
            summarizedValue = fieldValues.reduce((a, b) => (a < b ? a : b));
            break;
          case "avg":
            summarizedValue =
              fieldValues.reduce((a, b) => a + b) / fieldValues.length;
            break;
        }
      }else{
        summarizedValue = "0";
      }
      return {
        title: fieldTitle,
        value:
          summarizedValue instanceof Date
            ? Utils.date.toUserFormat(summarizedValue, this.userDateFormat)
            : Utils.number.toUserFormat(
                summarizedValue,
                this.userDecSep,
                this.userThouSep
              ),
      };
    },
  },
};
</script>
<style>
.icon {
  order: 0;
}

.header {
  order: 1;
}
.v-expansion-panel-content__wrap {
  padding-right: 0px !important;
}
.no-padding .v-expansion-panel-content__wrap {
  padding: 0px !important;
}
</style>